import { alpha } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

// The shell's single brand gradient/glow, derived from the theme's actual primary
// color (which a tenant can override) rather than a hardcoded hex pair — so the
// app bar/sidebar/account avatar all reflect a tenant's real brand color instead
// of a disconnected purple. Monochromatic (main -> dark) so it stays harmonious
// no matter what arbitrary color a tenant sets as their primary.
export const getShellGradient = (theme: Theme, direction: string = '135deg') =>
    `linear-gradient(${direction}, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`;

export const getShellGlow = (theme: Theme, alphaValue: number = 0.35) =>
    alpha(theme.palette.primary.main, alphaValue);
